import React from "react";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";
import { enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { locales } from "@me-team/common/src/hooks/helpers";

const CustomDatePicker: React.FC<ReactDatePickerProps> = ({
    selected,
    id,
    name,
    className,
    placeholderText,
    onChange,
    wrapperClassName,
    dateFormat,
    filterDate,
    maxDate,
    showYearDropdown = true,
    showMonthDropdown = true,
    yearDropdownItemNumber,
    scrollableYearDropdown = true,
    scrollableMonthYearDropdown = true,
    calendarStartDay,
    todayButton,
    isClearable,
    filterTime,
    showTimeInput = false,
    timeInputLabel = "Time",
    timeFormat = "HH:mm:ss",
    onKeyDown,
    customInput,
    onCalendarOpen,
    customTimeInput,
    icon,
    showIcon,
    toggleCalendarOnIconClick,
    disabled,
}) => {
    const { t, i18n } = useTranslation();
    return (
        <DatePicker
            selected={selected}
            id={id}
            name={name}
            className={className}
            placeholderText={placeholderText}
            onChange={onChange}
            wrapperClassName={wrapperClassName}
            dateFormat={dateFormat}
            filterDate={filterDate}
            locale={locales[i18n.language] || enUS}
            maxDate={maxDate}
            filterTime={filterTime}
            showYearDropdown={showYearDropdown}
            showMonthDropdown={showMonthDropdown}
            scrollableYearDropdown={scrollableYearDropdown}
            scrollableMonthYearDropdown={scrollableMonthYearDropdown}
            yearDropdownItemNumber={yearDropdownItemNumber}
            calendarStartDay={calendarStartDay}
            todayButton={todayButton}
            isClearable={isClearable}
            showTimeInput={showTimeInput}
            timeInputLabel={t(timeInputLabel)}
            timeFormat={timeFormat}
            onKeyDown={onKeyDown}
            customInput={customInput}
            onCalendarOpen={onCalendarOpen}
            customTimeInput={customTimeInput}
            icon={icon}
            showIcon={showIcon}
            toggleCalendarOnIconClick={toggleCalendarOnIconClick}
            disabled={disabled}
        />
    );
};

export default CustomDatePicker;
